import { IGoal } from "motw_core/Entity/IGoal";

export const Validate = (state: IGoal): string => {
    let error = "";

    const hasMissingValues =
        state.name === ""
        || state.weeklyrate === 0
        || state.startdate === ""
        || state.icon === "";

    if (hasMissingValues) {
        error = "One or more values are missing";
    }

    return error;
}